module.exports = __webpack_public_path__ + "img/by.da36390e.svg";